module.exports = __webpack_public_path__ + "img/0.a6d83e19.jpeg";